import React from 'react';
import { Text } from 'rebass';

interface SkillBoxProps {
  children: string;
  mr?: string | number | string[] | number[];
  py?: string | number | string[] | number[];
  px?: string | number | string[] | number[];
}

const SkillBox: React.FC<SkillBoxProps> = ({ children, ...props }): JSX.Element => (
  <Text
    width="100%"
    fontSize={['14px']}
    fontWeight={6}
    textAlign="center"
    color="white"
    bg="primary"
    css="
      border-radius: 5px;
      :last-child { 
        margin-right: 0; 
      }
    "
    {...props}
  >
    {children}
  </Text>
);

export default SkillBox;
